import { User } from '@screentone/addon-auth-wrapper';

import env from 'utils/env';

export function getContextFromStorage() {
  const ctx: { user: User; header: Record<string, string> } = { user: {} as User, header: {} };

  try {
    const raw = localStorage.getItem('okta-token-storage');
    if (raw) {
      const store = JSON.parse(raw) as { idToken?: { idToken?: string; claims: Record<string, any> } };
      const idTokenClaims = store.idToken?.claims;
      if (idTokenClaims) {
        ctx.user = idTokenClaims;
      }
    }
  } catch {
    // ignore
  }

  return ctx;
}

export function reportError(msg?: string, err?: Error) {
  const error = err ?? new Error(String(msg));
  const ctx = getContextFromStorage();

  if ((env.OKTA_ENV as string) === 'prd') {
    console.error(`${msg} - User context ${JSON.stringify(ctx)}`);
  }
  if (msg && err) {
    console.error(msg, error);
  } else if (msg) {
    console.error(msg);
  } else if (err) {
    console.error(error);
  }
}
